import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';

function useWindowWidth() {
  const [w, setW] = useState(window.innerWidth);
  useEffect(() => { const h=()=>setW(window.innerWidth); window.addEventListener('resize',h); return()=>window.removeEventListener('resize',h); }, []);
  return w;
}

// ✅ FormContent OUTSIDE Login component — fixes typing issue
function FormContent({ loginType, setLoginType, name, setName, phone, setPhone, email, setEmail, password, setPassword, loading, focused, setFocused, showPwd, setShowPwd, handleLogin }) {

  const IS = (field) => ({
    width:'100%', padding:'13px 16px',
    border:`2px solid ${focused===field?'#FF6B00':'#E8D5C4'}`,
    borderRadius:12, fontSize:'0.92rem',
    fontFamily:"'Outfit',sans-serif",
    outline:'none', transition:'all 0.2s',
    background:focused===field?'white':'#FAFAFA',
    boxShadow:focused===field?'0 0 0 4px rgba(255,107,0,0.1)':'none',
    color:'#1A0A00',
  });

  return (
    <>
      {/* Title */}
      <div style={{ marginBottom:22, textAlign:'center' }}>
        <div style={{ fontSize:'0.7rem', color:'#FF6B00', fontWeight:700, letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:5 }}>Welcome Back</div>
        <h2 style={{ fontFamily:"'Baloo 2',sans-serif", fontSize:'1.5rem', fontWeight:800, color:'#1A0A00', margin:0 }}>
          Sign in to <span style={{ color:'#FF6B00' }}>Voter App</span>
        </h2>
      </div>

      {/* Toggle Tabs */}
      <div style={{ display:'flex', gap:0, marginBottom:22, background:'#F5F0EC', borderRadius:14, padding:4 }}>
        {[
          { id:'user',  label:'👤 Enumerator', sub:'Name + Phone' },
          { id:'admin', label:'🛡️ Admin',         sub:'Email + Password' },
        ].map(t=>(
          <button key={t.id} type="button" onClick={()=>setLoginType(t.id)} style={{
            flex:1, padding:'10px 8px', border:'none', borderRadius:10,
            cursor:'pointer', transition:'all 0.2s', fontFamily:"'Outfit',sans-serif",
            background: loginType===t.id ? 'white' : 'transparent',
            boxShadow: loginType===t.id ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
          }}>
            <div style={{ fontWeight:700, fontSize:'0.78rem', color: loginType===t.id?'#E55100':'#9E6040' }}>{t.label}</div>
            <div style={{ fontSize:'0.65rem', color: loginType===t.id?'#FF6B00':'#C4A090', marginTop:2 }}>{t.sub}</div>
          </button>
        ))}
      </div>

      {/* Form */}
      <form onSubmit={handleLogin}>
        {loginType === 'user' ? (
          <>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:'0.72rem', fontWeight:700, color:'#BF360C', marginBottom:7, textTransform:'uppercase', letterSpacing:'0.8px' }}>Your Name</label>
              <div style={{ position:'relative' }}>
                <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', fontSize:'1rem', pointerEvents:'none' }}>👤</span>
                <input style={{ ...IS('name'), paddingLeft:42 }} placeholder="Enter your full name" value={name} onChange={e=>setName(e.target.value)} onFocus={()=>setFocused('name')} onBlur={()=>setFocused('')} autoComplete="name"/>
              </div>
            </div>
            <div style={{ marginBottom:22 }}>
              <label style={{ display:'block', fontSize:'0.72rem', fontWeight:700, color:'#BF360C', marginBottom:7, textTransform:'uppercase', letterSpacing:'0.8px' }}>Phone Number</label>
              <div style={{ position:'relative' }}>
                <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', fontSize:'1rem', pointerEvents:'none' }}>📱</span>
                <input type="tel" maxLength={10} style={{ ...IS('phone'), paddingLeft:42, paddingRight:52 }} placeholder="10-digit mobile number" value={phone} onChange={e=>setPhone(e.target.value.replace(/\D/g,'').slice(0,10))} onFocus={()=>setFocused('phone')} onBlur={()=>setFocused('')} autoComplete="tel"/>
                {phone.length>0 && <div style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', fontSize:'0.7rem', fontWeight:800, color:phone.length===10?'#00C853':'#FFB300', background:phone.length===10?'#E8F5E9':'#FFF9C4', padding:'2px 7px', borderRadius:99 }}>{phone.length}/10</div>}
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:'0.72rem', fontWeight:700, color:'#BF360C', marginBottom:7, textTransform:'uppercase', letterSpacing:'0.8px' }}>Email Address</label>
              <div style={{ position:'relative' }}>
                <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', fontSize:'1rem', pointerEvents:'none' }}>📧</span>
                <input type="email" style={{ ...IS('email'), paddingLeft:42 }} placeholder="admin@example.com" value={email} onChange={e=>setEmail(e.target.value)} onFocus={()=>setFocused('email')} onBlur={()=>setFocused('')} autoComplete="email"/>
              </div>
            </div>
            <div style={{ marginBottom:22 }}>
              <label style={{ display:'block', fontSize:'0.72rem', fontWeight:700, color:'#BF360C', marginBottom:7, textTransform:'uppercase', letterSpacing:'0.8px' }}>Password</label>
              <div style={{ position:'relative' }}>
                <span style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', fontSize:'1rem', pointerEvents:'none' }}>🔒</span>
                <input type={showPwd?'text':'password'} style={{ ...IS('password'), paddingLeft:42, paddingRight:44 }} placeholder="Enter your password" value={password} onChange={e=>setPassword(e.target.value)} onFocus={()=>setFocused('password')} onBlur={()=>setFocused('')} autoComplete="current-password"/>
                <button type="button" onClick={()=>setShowPwd(!showPwd)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', fontSize:'1rem', opacity:.6 }}>
                  {showPwd?'🙈':'👁️'}
                </button>
              </div>
            </div>
          </>
        )}

        <button type="submit" disabled={loading} style={{ width:'100%', padding:'14px', border:'none', borderRadius:14, background:loading?'#ccc':'linear-gradient(135deg,#E55100,#FF6B00,#FF9933)', backgroundSize:'200% 200%', animation:loading?'none':'gradientShift 3s ease infinite', color:'white', fontWeight:700, fontSize:'1rem', cursor:loading?'not-allowed':'pointer', fontFamily:"'Outfit',sans-serif", boxShadow:loading?'none':'0 6px 20px rgba(255,107,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', gap:10, transition:'all 0.3s' }}>
          {loading?<><span style={{ width:16,height:16,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'white',borderRadius:'50%',display:'inline-block',animation:'spin 0.7s linear infinite'}}/>Signing in...</>:<>🔐 LOGIN</>}
        </button>
      </form>

      {/* <div style={{ marginTop:14, padding:'10px 14px', background:'linear-gradient(135deg,#FFF3E0,#FFE0B2)', borderRadius:10, border:'1px solid #FFCC80', textAlign:'center' }}>
        <div style={{ fontSize:'0.68rem', color:'#BF360C', fontWeight:600 }}>
          {loginType==='user'?'🔒 No PIN required • Multi-user login • 24hr session':'🛡️ Admin login • Secure access'}
        </div>
      </div> */}
      <div style={{ marginTop:12, textAlign:'center', fontSize:'0.68rem', color:'#C4A090' }}>
        Powered by <strong style={{ color:'#FF6B00' }}>Influfly</strong>
      </div>
    </>
  );
}

export default function Login() {
  const [loginType, setLoginType] = useState('user');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const width = useWindowWidth();
  const isDesktop = width >= 1024;

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loginType==='user') {
      if (!name.trim()) { toast.error('Please enter your name'); return; }
      if (phone.length<10) { toast.error('Enter valid 10-digit phone'); return; }
    } else {
      if (!email.trim()) { toast.error('Please enter email'); return; }
      if (!password.trim()) { toast.error('Please enter password'); return; }
    }
    setLoading(true);
    try {
      if (loginType==='user') await login(null, null, name.trim(), phone.trim());
      else await login(email.trim(), password.trim(), null, null);
      navigate('/');
    } catch(err) {
      toast.error(err.response?.data?.error||'Login failed');
    } finally { setLoading(false); }
  };

  const formProps = { loginType, setLoginType, name, setName, phone, setPhone, email, setEmail, password, setPassword, loading, focused, setFocused, showPwd, setShowPwd, handleLogin };

  return (
    <div style={{ minHeight:'100vh', fontFamily:"'Outfit',sans-serif", background:'linear-gradient(160deg,#FFF4ED,#FFF0E8)', display:'flex', alignItems:'center', justifyContent:'center', padding:isDesktop?'0':'24px 20px' }}>

      {isDesktop ? (
        <div style={{ display:'flex', width:'100%', height:'100vh' }}>
          <div style={{ flex:1, overflow:'hidden' }}>
            <video autoPlay loop muted playsInline style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}>
              <source src="/images/bjp-login.mp4" type="video/mp4"/>
            </video>
          </div>
          <div style={{ width:460, background:'white', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'40px', boxShadow:'-8px 0 40px rgba(0,0,0,0.08)', overflowY:'auto' }}>
            <div style={{ width:'100%', maxWidth:380 }}>
              <FormContent {...formProps}/>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ width:'100%', maxWidth:420, display:'flex', flexDirection:'column', alignItems:'center' }}>
          <div style={{ width:120, height:120, borderRadius:'50%', overflow:'hidden', border:'3px solid #FF6B00', boxShadow:'0 6px 24px rgba(255,107,0,0.35)', marginBottom:12 }}>
            <video autoPlay loop muted playsInline style={{ width:'100%', height:'100%', objectFit:'cover' }}>
              <source src="/images/bjp-login.mp4" type="video/mp4"/>
            </video>
          </div>
          <div style={{ textAlign:'center', marginBottom:14 }}>
            <div style={{ fontFamily:"'Baloo 2',sans-serif", fontSize:'1.1rem', fontWeight:800, color:'#E55100' }}>भारतीय जनता पार्टी</div>
            <div style={{ fontSize:'0.68rem', color:'#9E6040', fontWeight:600, marginTop:2 }}>Voter Data Management System</div>
          </div>
          <div style={{ width:'100%', background:'white', borderRadius:24, padding:'22px 20px', boxShadow:'0 8px 32px rgba(255,107,0,0.12)', border:'1px solid rgba(255,107,0,0.1)' }}>
            <FormContent {...formProps}/>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes gradientShift{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
      `}</style>
    </div>
  );
}